import { literalValues } from "@shared/validation/literal-values";

export const COMPANY_ONBOARDING_STATUS = {
  NOT_ON_REPACKIFY: "not_on_repackify",
  INVITED: "invited",
  SIGNED_IN: "signed_in",
  SET_UP: "set_up",
} as const;

export const COMPANY_ONBOARDING_STATUSES = literalValues(COMPANY_ONBOARDING_STATUS);

export type CompanyOnboardingStatus = (typeof COMPANY_ONBOARDING_STATUSES)[number];

export const COMPANY_ONBOARDING_STATUS_LABELS: Record<CompanyOnboardingStatus, string> = {
  not_on_repackify: "Not on Repackify",
  invited: "Invited",
  signed_in: "Signed in",
  set_up: "Set up",
};

export const ONBOARDING_STEP = {
  CAN_LOG_IN: "can_log_in",
  BUSINESS_DETAILS: "business_details",
  SITE_DETAILS: "site_details",
  LISTINGS_LIVE: "listings_live",
  PAYOUTS: "payouts",
  BILLING: "billing",
  FIRST_PURCHASE_ORDER: "first_purchase_order",
  FIRST_ORDER_PAID: "first_order_paid",
} as const;

export const ONBOARDING_STEPS = literalValues(ONBOARDING_STEP);

export type OnboardingStepKey = (typeof ONBOARDING_STEPS)[number];

export const ONBOARDING_STEP_LABELS: Record<OnboardingStepKey, string> = {
  can_log_in: "Can log in",
  business_details: "Business details",
  site_details: "Dock and site details",
  listings_live: "Listings live",
  payouts: "Gets paid by Stripe",
  billing: "Billing set up",
  first_purchase_order: "First purchase order accepted on Repackify",
  first_order_paid: "First order paid on Repackify",
};

export const SETUP_STEP_DONE_ACTION = "setup_step_done";

export const ONBOARDING_SIDE = {
  REPACKIFY: "repackify",
  CUSTOMER: "customer",
} as const;

export const ONBOARDING_SIDES = literalValues(ONBOARDING_SIDE);

export type OnboardingSide = (typeof ONBOARDING_SIDES)[number];

export const PERSON_ACCESS = {
  CAN_LOG_IN: "can_log_in",
  INVITED: "invited",
  ASKED_TO_JOIN: "asked_to_join",
  NO_LOGIN: "no_login",
} as const;

export const PERSON_ACCESS_STATES = literalValues(PERSON_ACCESS);

export const ONBOARDING_LIMITS = {
  members: 100,
  contacts: 100,
  invitations: 20,
  claims: 20,
  joinRequests: 20,
  orderScan: 100,
  repackifyListingScan: 50,
  userMemberships: 20,
} as const;
